import { NSARouterMakerResult } from "namirasoft-account-react";
import { JobInputRow, JobRow } from "namirasoft-job-arranger";
import React, { createRef } from "react";
import { JobArrangerEntities } from "../JobArrangerEntities";
import { JobArrangerLayout } from '../JobArrangerLayout';
import { JobArrangerProps } from "../JobArrangerProps";
import { JobStatusObject } from "../JobStatusObject";
import { JobStatusHistory } from "../components/JobStatusHistory";
import { JobStatusPanel } from "../components/JobStatusPanel";

interface JobListPageProps extends NSARouterMakerResult, JobArrangerProps { }

interface JobListPageState { }

export default class JobListPage extends React.Component<JobListPageProps, JobListPageState>
{
    private LayoutRef = createRef<JobArrangerLayout<JobRow, JobInputRow>>();
    private JobStatusPanel_Ref = createRef<JobStatusPanel>();
    private JobStatusHistory_Ref = createRef<JobStatusHistory>();

    constructor(props: JobListPageProps)
    {
        super(props);
        this.state = {};
    }

    override render()
    {
        return (
            <JobArrangerLayout<JobRow, JobInputRow>
                ref={this.LayoutRef}
                {...this.props}
                action={{
                    title: "",
                    description: "List of all the jobs you've added through the extension.",
                    menus: {}
                }}
                pages={{
                    entity: JobArrangerEntities.job(this.props),
                    list: {
                        ui: {
                            getRowAttributes(row_value)
                            {
                                let backgroundColor = JobStatusObject.get(row_value.status)?.color;
                                return { style: { backgroundColor } };
                            },
                            getChildrenAfter: (_id, row) =>
                            {
                                if (!row)
                                    return null;

                                return (
                                    <>
                                        <JobStatusPanel
                                            {...this.props}
                                            ref={this.JobStatusPanel_Ref}
                                            job={row}
                                            onChange={() =>
                                            {
                                                this.LayoutRef.current?.NSALayout_Ref.current?.NSASectionList_Ref.current?.NSATable_Main.current?.reload(null, null);
                                                this.LayoutRef.current?.NSALayout_Ref.current?.NSASectionList_Ref.current?.NSASectionViewTabPage_Ref.current?.reload();
                                                this.JobStatusHistory_Ref.current?.load();
                                            }}
                                        />
                                        <JobStatusHistory
                                            {...this.props}
                                            ref={this.JobStatusHistory_Ref}
                                            job={row}
                                            onChange={() => this.JobStatusPanel_Ref.current?.reloadJob()}
                                        />
                                    </>
                                )
                            }
                        }
                    }
                }}
            >
                <></>
            </JobArrangerLayout>
        );
    }
}